export default __webpack_public_path__ + "static/media/Q32024.fc8a5004.pdf";